export const noop = <T>(any: T): T => any
